var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userReferrer)?_c('ReferralOnboarding',{attrs:{"step-slug":"onboarding-referral","user-referrer":_vm.userReferrer}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }